<footer class="footer mt-auto py-3">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <span>We accept:</span>
                    </div>
                    <div class="col-12 col-sm-9">
                        <div class="payment-options-wrapper">
                            <div class="payment-options">
                                <i class="fa fa-cc-visa"></i> <i class="fa fa-cc-mastercard"></i> <i class="fa fa-cc-amex"></i> <i class="fa fa-cc-paypal"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <div class="row copyright">
                    <div class="col-12 col-sm-5">
                        <a
                            href="https://www.paragontesting.ca/paragon-legal-agreements-and-policies/privacy-policy/"
                            class="link"
                            target="_blank"
                        >Privacy Policy</a>
                    </div>
                    <div class="col-12 col-sm-7">
                        <span>@{{currentYear}} Paragon Testing Enterprises</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
